<ds-tabs>
  <ds-tabs-label
    for="a"
    (click)="validateAllDSPcheck(); $event.preventDefault()"
    >Available Vehicle
  </ds-tabs-label>

  <ds-tabs-content id="a">
    <div class="tab-content">
      <ng-container *ngIf="isAvailableTabClicked; else notYetSearched">
        <ng-container *ngIf="rowsData && rowsData.length > 0; else noStock">
          <app-table
            [rowsData]="rowsData"
            [columnData]="columnData"
            (downloadClick)="onDownloadClick($event)"
            (transferClick)="transferVehicle($event)"
            [showTable]="showTable"
          ></app-table>
        </ng-container>
      </ng-container>
    </div>
  </ds-tabs-content>

  <ds-tabs-label for="b" (click)="onBlockedVehicleTabClick()"
    >Blocked Vehicle</ds-tabs-label
  >
  <ds-tabs-content id="b">
    <div class="tab-content">
      <ng-container *ngIf="rowsData && rowsData.length > 0; else noStock">
        <app-table
          [rowsData]="rowsData"
          [columnData]="otpColumnData"
          [showTable]="showTable"
        ></app-table>
      </ng-container>
    </div>
  </ds-tabs-content>

  <ds-tabs-label for="c" (click)="onOTPTabClick()">OTP</ds-tabs-label>
  <ds-tabs-content id="c">
    <div class="tab-content">
      <ng-container *ngIf="rowsData && rowsData.length > 0; else noStock">
        <app-table
          [rowsData]="rowsData"
          [columnData]="otpColumnData"
          [showTable]="showTable"
          (downloadClick)="onDownloadClick($event)"
          (transferClick)="transferVehicle($event)"
        ></app-table>
      </ng-container>
    </div>
  </ds-tabs-content>

  <ds-tabs-label for="d" (click)="onQuotationTabClick()"
    >Quotation</ds-tabs-label
  >
  <ds-tabs-content id="d">
    <div class="tab-content">
      <ng-container *ngIf="rowsData && rowsData.length > 0; else noStock">
        <app-table
          [rowsData]="rowsData"
          [columnData]="quotationColumnData"
          [showTable]="showTable"
        ></app-table>
      </ng-container>
    </div>
  </ds-tabs-content>

  <ds-tabs-label for="e" (click)="onNscTabClick()">NSC Stock</ds-tabs-label>
  <ds-tabs-content id="e">
    <div class="tab-content">
      <ng-container *ngIf="rowsData && rowsData.length > 0; else noStock">
        <app-table
          [rowsData]="rowsData"
          [columnData]="nscColumnData"
          [showTable]="showTable"
        ></app-table>
      </ng-container>
    </div>
  </ds-tabs-content>

  <ds-tabs-label for="f" (click)="onInboundTabClick()"
    >Inbound Stock</ds-tabs-label
  >
  <ds-tabs-content id="f">
    <div class="tab-content">
      <ng-container *ngIf="rowsData && rowsData.length > 0; else noStock">
        <app-table
          [rowsData]="rowsData"
          [columnData]="inBoundColumnData"
          [showTable]="showTable"
        ></app-table>
      </ng-container>
    </div>
  </ds-tabs-content>

  <ds-tabs-label for="g" (click)="onOutboundTabClick()"
    >Outbound Stock</ds-tabs-label
  >
  <ds-tabs-content id="g">
    <div class="tab-content">
      <ng-container *ngIf="rowsData && rowsData.length > 0; else noStock">
        <app-table
          [rowsData]="rowsData"
          [columnData]="outboundColumnData"
          [showTable]="showTable"
        ></app-table>
      </ng-container>
    </div>
  </ds-tabs-content>

  <ds-tabs-label for="h" (click)="onRFSTabClick()"
    >Reserved for Sale</ds-tabs-label
  >
  <ds-tabs-content id="h">
    <div class="tab-content">
      <ng-container *ngIf="rowsData && rowsData.length > 0; else noStock">
        <app-table
          [rowsData]="rowsData"
          [columnData]="reservedStockColumnData"
          [showTable]="showTable"
          (downloadClick)="onDownloadClick($event)"
          (transferClick)="transferVehicle($event)"
        ></app-table>
      </ng-container>
    </div>
  </ds-tabs-content>

  <ds-tabs-label for="j" (click)="onDemoTabClick()">Demo Stock</ds-tabs-label>
  <ds-tabs-content id="j">
    <div class="tab-content">
      <ng-container *ngIf="rowsData && rowsData.length > 0; else noStock">
        <app-table
          [rowsData]="rowsData"
          [columnData]="demoStockColumnData"
          [showTable]="showTable"
          (uploadSuccess)="onUploadSuccess()"
        ></app-table>
      </ng-container>
    </div>
  </ds-tabs-content>
</ds-tabs>

<ds-modal
  #transferConfirmationModal
  [ds-modal-trigger-for]="transferConfirmationModal"
  [(isModalOpen)]="modalIsOpen"
  [dimensionsConfig]="{ width: '585px' }"
  [detachFooter]="true"
>
  <ds-box-header style="font-size: xx-large; font-weight: bold">
    {{ modalData.title }}
  </ds-box-header>
  <ds-box-content>
    <div>
      <span>
        {{ modalData.message }}
      </span>
    </div>
  </ds-box-content>
</ds-modal>
<ng-template #notYetSearched>
  <div
    class="no-data-message"
    style="
      display: flex;
      align-items: center;
      justify-content: center;
      height: 45vh;
      min-height: 450px;
      text-align: center;
      padding-left: 2rem;
    "
  >
    <div>
      <h1 style="margin: 0">NO SEARCH RESULTS YET</h1>
      <p style="margin: 0">
        Use the filters and click 'Search' to find what you need.
      </p>
    </div>
  </div>
</ng-template>
<ng-template #noStock>
  <div
    class="no-data-message"
    style="
      display: flex;
      align-items: center;
      justify-content: center;
      height: 45vh;
      min-height: 450px;
      text-align: center;
      padding-left: 2rem;
    "
  >
    <div>
      <h1 style="margin: 0">NO SEARCH RESULTS FOUND</h1>
      <p style="margin: 0">
        Try adjusting your search criteria in the filters.
      </p>
    </div>
  </div>
</ng-template>
